import type { ContractBalance } from 'src/graphql/generated';
import type { AdvertiserContractTrackingData } from 'src/types';

export const getContractTrackingData = (
  advertiserContracts?: ContractBalance[],
): AdvertiserContractTrackingData | undefined => {
  if (!advertiserContracts) {
    return undefined;
  }

  const trackingData: AdvertiserContractTrackingData = {
    advertiserContractType: [],
    advertiserContractIsDollarBased: [],
    advertiserContractValue: [],
    advertiserContractValueCurrency: [],
    advertiserContractBalance: [],
    advertiserContractAdType: [],
  };

  if (advertiserContracts) {
    advertiserContracts.forEach((contract) => {
      trackingData.advertiserContractType.push(contract.contractType);
      trackingData.advertiserContractAdType.push(contract.adType);
      trackingData.advertiserContractIsDollarBased.push(contract.dollarBased);
      trackingData.advertiserContractValueCurrency.push(
        contract.totalValue.dollars.original.currency,
      );
      trackingData.advertiserContractValue.push(
        contract.totalValue.dollars.original.value,
      );
      trackingData.advertiserContractBalance.push(
        contract.totalValue.dollars.remaining.value,
      );
    });
  }

  return trackingData;
};
